import { render } from "./process-attachment.vue?vue&type=template&id=5d4a62e4"
import script from "./process-attachment.vue?vue&type=script&lang=js"
export * from "./process-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__